import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { UserProvider } from "./context/UserContext";
import PrivateRoute from "./components/PrivateRoute";
import AdminRoute from "./components/AdminRoute";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// 📌 Public Pages
import Home from "./pages/Home";
import Jobs from "./pages/Jobs";
import JobDetails from "./pages/JobDetails";
import Services from "./pages/Services";
import ServiceDetails from "./pages/ServiceDetails";
import Events from "./pages/Events";
import EventDetails from "./pages/EventDetails";
import Offers from "./pages/Offers";


// 📌 Authentication Pages
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

// 📌 User Pages (Protected)
import Profile from "./pages/Profile";
import PostJob from "./pages/PostJob";
import PostService from "./pages/PostService";
import PostOffer from "./pages/PostOffer";
import PostEvent from "./pages/PostEvent";
import PostAd from "./pages/PostAd";
import MyBookings from "./pages/MyBookings";
import SupportTickets from "./pages/SupportTickets";

// 📌 Admin Pages (Protected)
import AdminDashboard from "./pages/AdminDashboard";
import AdminPayments from "./pages/AdminPayments";
import AdminConfig from "./pages/AdminConfig";
import AdminSupport from "./pages/AdminSupport";
import AdminBookings from "./pages/AdminBookings";
import AdminUserManagement from "./pages/AdminUserManagement";

// 📌 Classifieds Pages (New)
import ClassifiedsPage from "./pages/ClassifiedsPage";
import PostClassified from "./pages/PostClassified";

// 📌 Other Pages
import Support from "./pages/Support";
import NotFound from "./pages/NotFound";

import "./styles/Global.css";
import BookTickets from "./pages/BookTickets";
import NewsLetter from "./pages/NewsLetter";
import Opportunities from "./pages/Opportunities";
import Subscription from "./pages/Subscription";
import MyOpportunities from "./pages/MyOpportunities";
import ReferAFriend from "./pages/ReferAFriend";
import AboutUs from "./pages/about";
import Contact from "./pages/contact";
import Explore from "./pages/Explore";
import ApplyNowJob from "./pages/ApplyNowJob";
import Notifications from "./pages/Notifications";
import ClassifiedsPageDetails from "./pages/ClassifiedsPageDetails";
import AdminJobs from "./pages/AdminJobs";
import AdminServices from "./pages/AdminServices";
import AdminOffers from "./pages/AdminOffers";
import AdminClassifieds from "./pages/AdminClassifieds";
import AdminEvents from "./pages/AdminEvents";
import AdminAds from "./pages/AdminAds";
import LocationandInterests from "./pages/LocationandInterests";
import PaymentHistory from "./pages/paymenthistory";

const App = () => {
  return (
    <UserProvider>
      <Router>
        <div className="app-container">
          <Navbar />
          <div className="main-content">
            <Routes>
              {/* 🌍 Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/job/:id" element={<JobDetails />} />
              <Route path="/services" element={<Services />} />
              <Route path="/service/:id" element={<ServiceDetails />} />
              <Route path="/events" element={<Events />} />
              <Route path="/event/:id" element={<EventDetails />} />
              <Route path="/offers" element={<Offers />} />
              
              <Route path="/classifieds" element={<ClassifiedsPage />} />{" "}
              {/* ✅ New Route */}
              <Route path="/support" element={<Support />} />
              <Route path="/mytickets" element={<SupportTickets/>} />
              <Route path="/booktickets/:id" element={<BookTickets />} />
              <Route path="/referafriend" element={<ReferAFriend />} />
              <Route path="/applynowjob" element={<ApplyNowJob />} />
              <Route path="/notifications" element={<Notifications />}></Route>
              <Route path="payment-history" element={<PaymentHistory />}></Route>
              {/* 🔐 Authentication */}
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              {/* 🔒 User-Specific Private Routes */}
              <Route
                path="/profile"
                element={<PrivateRoute element={<Profile />} />}
              />
              <Route
                path="/post-job"
                element={<PrivateRoute element={<PostJob />} />}
              />
              <Route
                path="/post-service"
                element={<PrivateRoute element={<PostService />} />}
              />
              <Route
                path="/post-offer"
                element={<PrivateRoute element={<PostOffer />} />}
              />
              <Route
                path="/post-event"
                element={<PrivateRoute element={<PostEvent />} />}
              />
              <Route
                path="/post-ad"
                element={<PrivateRoute element={<PostAd />} />}
              />
              <Route path="/my-bookings" element={<MyBookings />} />
              <Route path="/my-opportunities" element={<MyOpportunities />} />
              <Route
                path="/post-classified"
                element={<PrivateRoute element={<PostClassified />} />}
              />
              {/* 🛠️ Admin-Only Routes */}
              <Route
                path="/admin"
                element={<AdminRoute element={<AdminDashboard />} />}
              />
              <Route
                path="/admin/users"
                element={<AdminRoute element={<AdminUserManagement />} />}
              />
              <Route
                path="/admin/payments"
                element={<AdminRoute element={<AdminPayments />} />}
              />
              <Route
                path="/admin/configuration"
                element={<AdminRoute element={<AdminConfig />} />}
              />
              <Route
                path="/admin/support"
                element={<AdminRoute element={<AdminSupport />} />}
              />
              <Route
                path="/admin/bookings"
                element={<AdminRoute element={<AdminBookings />} />}
              />
              <Route
                path="/admin/jobs"
                element={<AdminRoute element={<AdminJobs />}></AdminRoute>}
              ></Route>
              <Route
                path="/admin/services"
                element={<AdminRoute element={<AdminServices />}></AdminRoute>}
              ></Route>
              <Route
                path="/admin/offers"
                element={<AdminRoute element={<AdminOffers />}></AdminRoute>}
              ></Route>
              <Route
                path="/admin/classifieds"
                element={
                  <AdminRoute element={<AdminClassifieds />}></AdminRoute>
                }
              ></Route>
              <Route
                path="/admin/ads"
                element={<AdminRoute element={<AdminAds />}></AdminRoute>}
              ></Route>
              <Route
                path="/admin/events"
                element={<AdminRoute element={<AdminEvents />}></AdminRoute>}
              ></Route>
              <Route path="/newsletter" element={<NewsLetter />}></Route>
              <Route path="/opportunities" element={<Opportunities />}></Route>
              <Route path="/subscription" element={<Subscription />}></Route>
              <Route path="/aboutus" element={<AboutUs />}></Route>
              <Route path="/contact" element={<Contact />}></Route>
              <Route path="/explore" element={<Explore />}></Route>
              <Route path="/locationandinterests" element={<LocationandInterests />}></Route>
              <Route
                path="/classifieds/:id"
                element={<ClassifiedsPageDetails></ClassifiedsPageDetails>}
              ></Route>
              {/* ❌ 404 - Page Not Found */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </UserProvider>
  );
};

export default App;
